import BaseApi from './BaseApi'

class SubscriptionService extends BaseApi {
  async getStatus() {
    return this.doRequest('get', '/v1/subscriptions/me/')
  }

  async createCheckout() {
    return this.doRequest('post', '/v1/subscriptions/checkout/')
  }

  async cancelSubscription() {
    return this.doRequest('delete', '/v1/subscriptions/cancel/')
  }
}

export default SubscriptionService
